"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../../DriveScout/Billing/Teller");
var saveToDisk_1 = require("../../../../common/helpers/saveToDisk");
var PaymentRequest_1 = require("../../../../common/payments/PaymentRequest");
var ViewOrderController = /** @class */ (function () {
    function ViewOrderController($state, OrdersModel, FlashService, OrderDetailsService, PoliciesModel, $q, UserService, UsersModel, order, Stripe3DSService) {
        var _this = this;
        /** Order.vue only emits the payment; this screen sends it and sees the answer, so it holds the key. */
        this.orderPayment = new PaymentRequest_1.PaymentRequest();
        this.loading = false;
        this.submitting = false;
        this.$state = $state;
        this.OrdersModel = OrdersModel;
        this.FlashService = FlashService;
        this.OrderDetailsService = OrderDetailsService;
        this.PoliciesModel = PoliciesModel;
        this.$q = $q;
        this.UsersModel = UsersModel;
        this.Stripe3DSService = Stripe3DSService;
        this.busy = false;
        this.page_by = 20;
        this.order = order;
        this.billingConfig = {
            gateway: "",
            gateway_config: {},
            policyMeta: {},
        };
        this.clearPaymentForm = false;
        this.currentUser = UserService.getCurrentUser();
        this.patchOrder = this.patchOrder.bind(this);
        this.submitPayment = this.submitPayment.bind(this);
        this.voidPayment = this.voidPayment.bind(this);
        this.voidOrder = this.voidOrder.bind(this);
        this.sendOrder = this.sendOrder.bind(this);
        this.printOrder = this.printOrder.bind(this);
        this.viewPayment = this.viewPayment.bind(this);
        this.viewCustomer = this.viewCustomer.bind(this);
        this.handlePaypalPaymentSuccess =
            this.handlePaypalPaymentSuccess.bind(this);
        this.inDollars = Teller_1.inDollars.bind(this);
        this.$q
            .all([
            this.PoliciesModel.getByID("billing"),
            this.OrdersModel.getDetails({ id: order.id }),
        ])
            .then(function (responses) {
            var orderParam = order.student
                ? order
                : __assign(__assign({}, order), { student: null });
            _this.order = _this.OrderDetailsService.setupOrderDetails(responses[1], orderParam);
            _this.billingConfig = _this.OrderDetailsService.configureBilling({
                policy: responses[0].policy,
            });
            _this.clearPaymentForm = false;
            _this.loading = false;
        });
    }
    ViewOrderController.prototype.patchOrder = function (updatedOrder) {
        this.order = updatedOrder;
    };
    ViewOrderController.prototype.submitPayment = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var payment, response, threeDSResult, confirmResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payment = data.payment;
                        this.submitting = true;
                        if (!payment.order_id) {
                            payment.order_id = this.order.id;
                        }
                        this.OrderDetailsService.setPayment(payment);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.OrderDetailsService.submitPayment(this.orderPayment)];
                    case 2:
                        response = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.answered(response));
                        if (!this.Stripe3DSService.isThreeDSecureRequired(response)) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Stripe3DSService.handle3DSChallenge(response.client_secret, this.billingConfig.gateway_config.stripe_publishable_key)];
                    case 3:
                        threeDSResult = _a.sent();
                        if (!threeDSResult.success) {
                            this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.challengeFailed(threeDSResult));
                            this.submitting = false;
                            this.FlashService.setMessage({
                                type: "error",
                                message: threeDSResult.error ||
                                    "Payment authentication failed. Please try again.",
                            });
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.Stripe3DSService.confirmOrderPayment(this.order.id, response.payment_intent_id, {
                                student_id: this.order.student.id,
                                amount: response.amount,
                            })];
                    case 4:
                        confirmResponse = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.answered(confirmResponse));
                        this.handlePaymentSuccess(confirmResponse);
                        return [2 /*return*/];
                    case 5:
                        // Standard payment success (no 3DS required)
                        this.handlePaymentSuccess(response);
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        this.orderPayment.settled(PaymentRequest_1.PaymentOutcome.failed(error_1));
                        this.submitting = false;
                        return [3 /*break*/, 7];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    ViewOrderController.prototype.handlePaymentSuccess = function (response) {
        this.FlashService.setMessage({
            type: "success",
            message: response.message,
        });
        this.submitting = false;
        this.$state.go("drivecoach.admin.students.view", {
            userId: this.order.student.id,
        }, { reload: true });
    };
    ViewOrderController.prototype.voidPayment = function (data) {
        var _this = this;
        var payment_id = data.payment_id, index = data.index;
        this.submitting = true;
        this.UsersModel.voidPayment({
            student_id: this.order.student.id,
            payment_id: payment_id,
        })
            .then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.order.payments.splice(index, 1, response.payment);
            _this.patchOrder(_this.order);
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.voidOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.voidOrder(data.order_id)
            .then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.order.status = "VOID"; // DS-PORT-DEFECT (drivescout-vue3 M4 slice 3, 2026-10-07): row F-owed-void-stale: Void Order patches only status, and the void answer carries no order (VoidOrdersController.php:51-53), so Order.vue's Amount Owed, which reads financial_summary before it tests VOID (Order.vue:644-647), keeps the pre-void balance (Net received its pre-void sum) until a reload, where the re-read summary has collection_closed and Amount Owed is $0.00; fixed in the port (the order is re-read).
            _this.patchOrder(_this.order);
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.sendOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.sendOrder(data.order_id, { recipient: data.receipt_email })
            .then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.printOrder = function (data) {
        var _this = this;
        this.submitting = true;
        this.OrdersModel.printOrder(data.order_id)
            .then(function (response) {
            _this.submitting = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            (0, saveToDisk_1.saveToDisk)(response.url);
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    ViewOrderController.prototype.viewPayment = function (data) {
        this.submitting = true;
        this.$state.go("drivecoach.admin.crm.payment", {
            paymentId: data.payment_id,
        });
    };
    ViewOrderController.prototype.viewCustomer = function (data) {
        this.$state.go("drivecoach.admin.students.view", {
            userId: data.student_id,
        });
    };
    ViewOrderController.prototype.handlePaypalPaymentSuccess = function (data) {
        this.handlePaymentSuccess(data);
    };
    return ViewOrderController;
}());
ViewOrderController.$inject = [
    "$state",
    "OrdersModel",
    "FlashService",
    "OrderDetailsService",
    "PoliciesModel",
    "$q",
    "UserService",
    "UsersModel",
    "order",
    "Stripe3DSService",
];
exports.default = ViewOrderController;
